// This code would typically be in your index.js or a global utility file
// that runs before your React app fully mounts.

(function() {
  const MAX_ERRORS = 10; // Define the maximum number of errors to store
  let capturedErrors = [];

  // Define keywords or patterns to identify errors to ignore
  const IGNORE_ERROR_PATTERNS = [
    /ResizeObserver loop limit exceeded/i, // Original ResizeObserver error
    /Find more than one child node with `children` in ResizeObserver\. Please use ResizeObserver\.Collection instead\./i, // The new specific ResizeObserver error

    // CORS-related patterns
    /Failed to fetch/i, // General network error, often related to CORS
    /Cross-Origin Resource Sharing policy/i, // Explicit CORS policy error
    /CORS header 'Access-Control-Allow-Origin' missing/i,
    /No 'Access-Control-Allow-Origin' header is present/i,
    /has been blocked by CORS policy/i,
    /blocked by Cross-Origin Resource Sharing policy/i,
  ];

  // Override console.error to capture errors
  const originalConsoleError = console.error;
  console.error = function(...args) {
    // Call the original console.error to keep its default behavior
    originalConsoleError.apply(console, args);

    // Get the full error message as a single string for pattern matching
    const errorString = args.map(arg => {
      if (arg instanceof Error) {
        return arg.stack || arg.message;
      }
      return String(arg);
    }).join(' ');

    // Check if the error string matches any of the ignore patterns
    const shouldIgnore = IGNORE_ERROR_PATTERNS.some(pattern => pattern.test(errorString));

    if (shouldIgnore) {
      // Don't capture this error if it matches an ignore pattern
      return;
    }

    // Capture the error message or relevant details
    const errorDetails = {
      timestamp: new Date().toISOString(),
      message: errorString, // Use the already formatted string
      // You can add more context here if needed, like original args, etc.
    };

    capturedErrors.push(errorDetails);

    // Keep only the last MAX_ERRORS
    if (capturedErrors.length > MAX_ERRORS) {
      capturedErrors = capturedErrors.slice(capturedErrors.length - MAX_ERRORS);
    }
  };

  // Expose a function to retrieve captured errors
  window.getCapturedErrors = function() {
    return [...capturedErrors]; // Return a copy to prevent external modification
  };

  // Expose a function to clear captured errors
  window.clearCapturedErrors = function() {
    capturedErrors = [];
  };
})();